"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const context_1 = require("./context");
const OsmosysAlert_1 = require("../OsmosysAlert");
const react_loops_1 = require("react-loops");
const OsmosysUndesiredState_1 = require("../OsmosysUndesiredState");
const hooks_1 = require("./hooks");
exports.OsmosysCanvasPageUndesiredState = () => {
    const { canvasQueries, ready } = context_1.useOsmosysCanvasPageContext();
    const { hasFailed, failedQueries } = hooks_1.useCanvasQueries(canvasQueries);
    if (!ready && hasFailed) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(OsmosysUndesiredState_1.OsmosysUndesiredState, { message: "Failed to load", size: "lg" }),
            react_1.default.createElement(react_loops_1.For, { of: failedQueries }, error => {
                return (react_1.default.createElement(OsmosysAlert_1.OsmosysAlert, { errorPrefix: "Unable to load page", apolloError: error && error.result && error.result.error, retry: error && error.result && error.result.refetch, floatBottom: true }));
            })));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
//# sourceMappingURL=UndesiredState.js.map